module.exports = __webpack_public_path__ + "static/media/arrow-right-thin.5bede857.svg";